<template>
  <div>
    <virtual-list
      ref="vsl"
      class="virtual-list list-unstyled mt-2 mb-0 overflow-auto"
      style="max-height: 20vh;"

      :root-tag="'ul'"
      :data-key="'id'"
      :data-sources="messages"
      :data-component="messageOne"

      @tobottom="onToBottom"
      @scroll="onScroll"
    >
      <div
        slot="footer"
        class="footer"
      >
        <div v-show="loading && Boolean(messages.length)">
          {{ $t('home.loading') }}
        </div>
      </div>
    </virtual-list>
  </div>
</template>

<script>
import {mapState} from 'vuex';
import axios from 'axios';
import debounce from 'lodash.debounce';
import VirtualList from 'vue-virtual-scroll-list';
import messageOne from './OneSearchHeaderRoomComponents';
import catchDispatch from "../../../../utils/catchDispatch";

export default {
  components: {
    VirtualList,
  },
  props: {
    roomId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      messageOne,

      loading: false,
      cancelToken: false,
      scrollBottomFinished: false,
      messages: [],

      page: 1,
      page_size: 20,
    }
  },
  computed: {
    ...mapState('room', [
      'messageIdSearch',
    ]),
    query() {
      return this.$store.state.roomSearch.query;
    },
  },
  watch: {
    query() {
      this.fetchDebounce();
    },
    messageIdSearch(message_id) {
      // todo надо ли кролить
      return;
      const findIndex = this.messages.findIndex(({id}) => message_id === id);
      if (!findIndex) return;
      const {vsl} = this.$refs;
      const offset = vsl.virtual.getOffset(findIndex);
      vsl.scrollToOffset(offset);
    },
  },
  mounted() {
    this.fetchReset();
  },
  methods: {
    fetchReset() {
      this.loading = false;
      this.cancelSource?.cancel();
      this.cancelToken = false;
      this.scrollBottomFinished = false;
      this.messages = [];
      this.page = 1;
    },
    fetchDebounce: debounce(function () {
      this.fetchReset()
      this.fetch()
    }, 300),
    fetch() {
      this.cancelSource?.cancel()
      this.cancelSource = axios.CancelToken.source()
      const {token: cancelToken} = this.cancelSource

      const {query, roomId: chat_id} = this

      if (!query) {
        this.messages = [];
        return
      }

      this.loading = true
      axios
        .get(`/chats/api/v1/chats/search`, {
          cancelToken,
          params: {page: this.page, page_size: this.page_size, query, chat_id}
        })
        .then(({data: {body: {messages}}}) => {
          this.messages = this.messages.concat(...messages);
          if (messages.length < this.page_size) {
            this.scrollBottomFinished = true
          }
        })
        .catch(e => !axios.isCancel(e) && catchDispatch.call(this, e))
        .finally(() => this.loading = false)
    },
    onScroll() {
      if (this.loading) return;
      if (this.scrollBottomFinished) return;

      //console.info('ListMessageChatComponent | onScroll');

      const vsl = this.$refs.vsl;
      const is = ((vsl.getScrollSize() - vsl.getOffset()) - vsl.getClientSize()) < 50;
      is && this.onToBottom();
    },
    onToBottom() {
      if (this.scrollBottomFinished) return;
      if (this.loading) return;

      //console.info('ListMessageChatComponent | onToBottom');

      this.page += 1;
      this.fetch();
    },
  },
};
</script>

<style lang="scss" scoped>
.VueCarousel-slide > div {
  padding-left: 5px;
  padding-right: 5px;
}
</style>






